<template>
  <div v-if="props.hasFastDelivery" class="product-card__express-delivery">
    <Icon
      name="truck-fast"
      size="medium"
      class="product-card__express-delivery--icon"
    />
    {{
      $textDictionary['productsList.productCard.expressDelivery.label'] ??
      'Express Delivery available'
    }}
  </div>
  <LinkElement
    style-type="attraction-secondary"
    icon-type="no-icon"
    :link="props.productCardProps.link"
  >
    {{ $textDictionary['pdp.viewProduct.label'] ?? 'View Product' }}
  </LinkElement>
</template>

<script setup lang="ts">
import type { ProductCardProps } from '@hypercodestudio/basler-components/dist/components/modules/ProductCard.vue';
import { LinkElement, Icon } from '@hypercodestudio/basler-components';

interface Props {
  hasFastDelivery: boolean;
  productCardProps: ProductCardProps;
}

const props = defineProps<Props>();

const { $textDictionary } = useNuxtApp();
</script>
<style>
.product-card__express-delivery {
  display: flex;
  justify-content: center;
  width: 100%;
}
.product-card__express-delivery--icon {
  margin-right: 0.5rem;
}
</style>
